<template>
  <qx-card-form title="账期信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <div slot="recive" slot-scope="prop">
        <div v-show="prop.form.balanceType === '1'">
          <el-input class="inputBox" v-model="otherFormData.paymentDays" placeholder="请输入">
            <span slot="suffix" class="inputSlotText">天</span>
          </el-input>
        </div>
        <div v-show="prop.form.balanceType === '2'">
          <el-input class="appendInputBox" v-model="otherFormData.paymentMonth" placeholder="请输入">
            <span slot="suffix">个月后
              <el-select
                class="inputAppendSelect"
                slot="suffix"
                v-model="otherFormData.paymentDays"
                :clear="true"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in 31"
                  :key="item"
                  :label="item + '号'"
                  :value="item" />
              </el-select>
            </span>
          </el-input>
        </div>
      </div>
      <span class="tip" slot="quotaAmtStrTip">
        <el-tooltip content="若不填，则在该服务商的所有油站加油没有金额限制。若选择固定金额，则当司机在该服务商名下的油站扫码加油的金额超过设置的金额，且未结算时，司机将不能再扫码加油；结算后额度自动恢复。">
          <i class="el-icon-question warning"></i>
        </el-tooltip>
      </span>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      otherFormData: {
        paymentMonth: '', // 回单期限第几个月
        paymentDays: '', // 回单期限第几号
      },
      baseForm: {
        form: [
          {
            label: '结算方式',
            value: 'balanceType',
            type: 'select',
            width: '240px',
            onChange: () => {
              this.handleLabelTypeChange();
            },
            options: [
              {
                label: '账期',
                value: '1',
              },
              {
                label: '月结',
                value: '2',
              },
              {
                label: '无账期',
                value: '3',
              },
            ],
          },
          {
            label: '付款账期',
            value: 'recive',
            default: '1',
            slot: true,
          },
          {
            label: '授信金额',
            value: 'quotaAmtStr',
            type: 'input',
            hide: true,
          },
        ],
        rules: {
          balanceType: [ // 结算方式
            { required: true, message: '请选择结算方式', trigger: 'blur' },
          ],
          // recive: [ // 回单期限
          //   { required: true, message: '请输入回单期限', trigger: 'blur' },
          // ],
        },
      },
    };
  },
  methods: {
    receiveData (tar, val) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: val.serviceType !== '1',
        names: ['quotaAmtStr'],
      });
    },
    handleLabelTypeChange () {
      const balanceType = this.$refs.baseForm.getVal('balanceType');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: balanceType !== '1' && balanceType !== '2',
        names: ['recive'],
      });
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      let res = await this.handleSubData(true);
      return res;
    },

    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async init (data = {}) {
      if (data.balanceType) { // 结算方式
        data.balanceType = String(data.balanceType);
      }
      this.$refs.baseForm.setVal(data);
      this.setFormVal(this.otherFormData, data);
      this.handleLabelTypeChange();
    },
  },
};
</script>

<style scoped lang="scss">
.tip{
  margin-left: 16px;
  color: #999;
  span{
    color: #666;
    margin-right: 8px;
  }
}
</style>
